export default "__VITE_PUBLIC_ASSET__dd64ba3f__"